/**
 * Whether the discounted referral offer should be put in front of a logged-in
 * user. Pure so the conditions can be tested without rendering the dialog, which
 * would need the user context, Apollo and the router stood up.
 *
 * There is no "already offered" input: the cached referral code is the offer, and
 * acting on one consumes it. A user who has taken or declined the discount has no
 * code left, so `isReferralValid` is false and this returns false without any
 * separate bookkeeping.
 *
 * `isWelcomeOverlayUp` is the post-signup `welcomeApp=1` state, where the welcome
 * overlay is already on screen.
 */
export function shouldShowCelloReferralOffer({
  flagEnabled,
  isReferralValid,
  isWelcomeOverlayUp,
  dismissed,
}: {
  flagEnabled: boolean;
  isReferralValid: boolean;
  isWelcomeOverlayUp: boolean;
  dismissed: boolean;
}): boolean {
  if (!flagEnabled || !isReferralValid) {
    return false;
  }

  if (dismissed || isWelcomeOverlayUp) {
    return false;
  }

  return true;
}
